import React from 'react';

class Pager extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onClickForwardOne = this.onClickForwardOne.bind(this);
        this.onClickForwardLast = this.onClickForwardLast.bind(this);
        this.onClickBackOne = this.onClickBackOne.bind(this);
        this.onClickBackFirst = this.onClickBackFirst.bind(this);
        this.onPagerUpdate = this.onPagerUpdate.bind(this);
    }

    onPagerUpdate(e, nextStartIndex) {
        e.preventDefault();
        if (nextStartIndex != this.props.startIndex) this.props.onPagerUpdate(nextStartIndex);
    }

    onClickForwardOne(e) {
        let isFinalPage = this.props.startIndex + this.props.pageSize * 2 > this.props.totalCount;
        let nextStartIndex = this.props.startIndex + this.props.pageSize;
        (isFinalPage) ? this.onClickForwardLast(e) : this.onPagerUpdate(e, nextStartIndex);
    }

    onClickForwardLast(e) {
        let pageSizeDivisorOfTotalCount = (this.props.totalCount % this.props.pageSize == 0);
        let nextStartIndex = (pageSizeDivisorOfTotalCount) ? this.props.totalCount - this.props.pageSize : this.props.totalCount - (this.props.totalCount % this.props.pageSize);
        this.onPagerUpdate(e, nextStartIndex);
    }

    onClickBackOne(e) {
        let nextStartIndex = (this.props.startIndex - this.props.pageSize >= 0) ? this.props.startIndex - this.props.pageSize : 0;
        this.onPagerUpdate(e, nextStartIndex);
    }

    onClickBackFirst(e) {
        let nextStartIndex = 0;
        this.onPagerUpdate(e, nextStartIndex);
    }

    render() {
        let endIndex = (this.props.startIndex + this.props.pageSize < this.props.totalCount) ? this.props.startIndex + this.props.pageSize : this.props.totalCount;
        return (
            <div className="pager-container" >
                <span >
                    Showing items {this.props.startIndex + 1} to {endIndex} of {this.props.totalCount}
                </span>
                <a className="forward-last" href='#' onClick={this.onClickForwardLast} aria-label="forward-last button" />
                <a className="forward-one" href='#' onClick={this.onClickForwardOne} aria-label="forward-one button" />
                <a className="back-one" href='#' onClick={this.onClickBackOne} aria-label="back-one button" />
                <a className="back-first" href='#' onClick={this.onClickBackFirst} aria-label="back-last button" />
            </div>
        );
    }
}
export default Pager; 